import React, { Suspense, useContext, useEffect } from 'react';
import {
  routes,
} from '../routes/routes';
import {
  Redirect,
  Route,
  Switch
} from 'react-router-dom';
import LoginFunctions from '../utils/login.functions';
import { ConfigContext } from '../context/config.context';
import { useClearCache } from 'react-clear-cache';

const USER_TYPE = {
  1: 'admin',
  2: 'gestor',
  3: 'master',
}

const Contentx = () => { 

  const { config, load } = useContext(ConfigContext);
  const { isLatestVersion, emptyCacheStorage } = useClearCache();
  
  useEffect(() => {
    if (!isLatestVersion) {
      emptyCacheStorage()
    }
  // eslint-disable-next-line
  },[])
  
  return (
    <main>
        <Suspense fallback={'Cargando...'}>
          {config !== null && load ?
          <Switch>
            {routes[USER_TYPE[config.tipo]].map((route, idx) => {
              return route.component && (
                <Route
                  key={idx}
                  path={route.path}
                  exact={route.exact}
                  name={route.name}
                  render={props => (
                    LoginFunctions.isAuth() ?
                    <route.component {...props} />
                    :
                    <Redirect to={{ pathname: "/login" }} />
                  )} />
              )
            })}
            <Redirect from="/" to="/dashboard" />
          </Switch>
          : null }
        </Suspense>
    </main>
  )
}

export default Contentx;